import { Injectable } from '@angular/core';
import { DataBinding } from '@se/se.platform.base';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CpControlDataService {
    private readonly badges = new Map<string, BehaviorSubject<string | null>>();

    setBadge(binding: DataBinding, value: string) {
        this.subjectOf(this.badges, binding).next(value);
    }

    getBadge(binding: DataBinding) {
        return this.subjectOf(this.badges, binding).value;
    }

    getBadge$(binding: DataBinding) {
        return this.subjectOf(this.badges, binding).asObservable();
    }

    safeExit() {
        this.badges.forEach(b => b.complete());
        this.badges.clear();
    }


    private subjectOf<T>(dataType: Map<string, BehaviorSubject<T | null>>, binding: DataBinding) {
        const strBinding = binding.toStringForNotification();
        const subject = dataType.get(strBinding);
        if (subject) {
            return subject;
        }

        const result = new BehaviorSubject<T | null>(null);
        dataType.set(strBinding, result);

        return result;
    }
}
